;
export default {
    // 角色查询接口
    listRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowAuthor/queryRoleInfoList', params, response);
    }
};
